<template>
  <div ref="questionsElement" class="questions-wrapper">
    <div class="model-questions" data-copy="for-copied">
      <h2 class="title heading-m" :class="{ 'title--base': isBaseTab }">
        {{ totalQuestions ? 'Вопросы' : 'Есть вопрос о товаре?' }}
        <sup class="questions__count body-s-regular">
          {{ totalQuestions ? totalQuestions : '' }}</sup
        >
      </h2>
      <div
        :class="[
          'btns',
          'question__sliders-wrapper',
          'question__sliders-wrapper_no-images',
          { 'question__sliders-wrapper--base': isBaseTab },
          {
            'question__sliders-wrapper--questions': !isBaseTab,
          },
          {
            'question__sliders-wrapper--questions-padding': isPadding,
          },
          {
            'hide-mobile': isMd && questions && !isOtzyvyList,
          },
        ]"
      >
        <div
          v-if="!isBaseTab && isOtzyvyList"
          class="create-questions create-questions--mobile"
          :class="{
            'create-questions--base': isBaseTab,
            'create-questions--questions': questions,
            notempty: totalQuestions !== 0,
          }"
        >
          <ui-ui-button
            size="medium"
            :resize="true"
            @click="createNewQuestions"
          >
            Задать вопрос
          </ui-ui-button>
          <p>
            Вам ответит команда Price. Мы пришлём уведомление на вашу
            электронную почту, когда поступит ответ.
          </p>
        </div>
      </div>
      <div
        v-if="isOtzyvyList"
        :class="[
          'questions-wrap',
          {
            'questions-wrap--questions': !isBaseTab,
          },
        ]"
      >
        <template
          v-for="(question, index) of questions.items"
          :key="`question_${question.id}_${index}`"
        >
          <ModelQuestionsCard
            v-if="index < articleInView"
            ref="questionText"
            :item="question"
            :index="index"
            :is-base-tab="isBaseTab"
            :is-mobile="isMobile"
            :is-tablet="isLessLg"
            :class="{
              question: true,
              'question--base': isBaseTab,
              'question-single': totalQuestions === 1,
              'question-double': totalQuestions < 3,
            }"
            @to-route="$emit('to-route', 'voprosy')"
          />
        </template>
        <div
          v-if="isBaseTab && totalQuestions > 6"
          class="more-questions-section body-l-regular-long"
          @click="$emit('to-route', 'voprosy')"
        >
          <div>Все вопросы</div>
          <img :src="`/static/images/arrow-button-right.svg`" alt="arrow" />
        </div>
        <div
          v-if="isBaseTab && totalQuestions === 1"
          class="prompt-questions-section body-l-regular-long"
          @click="$emit('to-route', 'voprosy')"
        >
          <div>Скоро тут будет чей-то вопрос</div>
        </div>
      </div>

      <div
        v-if="pageCount > 1 || isBaseTab"
        :class="[
          'pagination-wrap',
          {
            'is-paginator': pageCount > 1 && !isBaseTab,
            'pagination-wrap-no-questions': !isOtzyvyList,
          },
        ]"
      >
        <template v-if="questions && isOtzyvyList">
          <slot name="pagination" />
          <template v-if="isBaseTab">
            <ui-ui-button class="new-question" @click="createNewQuestions">
              Задать вопрос
            </ui-ui-button>
            <ui-ui-button
              type="neutral"
              class="all-questions"
              @click="$emit('to-route', 'voprosy')"
            >
              Все вопросы
            </ui-ui-button>
          </template>
        </template>
        <ui-pagination
          v-if="!isBaseTab"
          class="pagination"
          :page-count="pageCount"
          :active="activePage"
          :wide="widePagination"
          @on-page-change="setActive"
        />
      </div>

      <template v-if="!isOtzyvyList">
        <div
          class="no-questions-wrapper question__sliders-wrapper"
          :class="{ 'no-questions-wrapper--base': isBaseTab }"
        >
          <div class="no-questions body-l-regular-long">
            К сожалению, пока никто не задавал вопросов — станьте первым. Вам
            ответит команда Price. Мы пришлём уведомление на вашу электронную
            почту, когда поступит ответ.
          </div>
          <ui-ui-button
            class="create-questions-button-mobile"
            :resize="true"
            size="medium"
            @click="createNewQuestions"
            >Задать вопрос
          </ui-ui-button>
        </div>
      </template>
      <client-only>
        <ModalsQuestionModal
          v-if="showFeedbackModal"
          :model-id="model.id"
          @close="closeFeedbackModal"
        />
      </client-only>
      <client-only>
        <ModalsConfirmModal
          v-if="showConfirmModal"
          title="Спасибо за вопрос!"
          description="Ваш вопрос отправлен на проверку, он будет опубликован на сайте, а вы получите ответ на электронную почту"
          apply-text="Хорошо"
          :on-apply="() => $emit('close')"
          @close="showConfirmModal = false"
        />
      </client-only>
    </div>
    <div
      class="create-questions create-questions--not-mobile"
      :class="{
        'create-questions--base': isBaseTab,
        'create-questions--questions': !isBaseTab,
        notempty: totalQuestions !== 0,
        empty: totalQuestions === 0,
      }"
    >
      <ui-ui-button :resize="true" @click="createNewQuestions"
        >Задать вопрос
      </ui-ui-button>
      <p class="body-l-regular-long">
        Вам ответит команда Price. Мы пришлём уведомление на вашу электронную
        почту, когда поступит ответ.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import ModelQuestionsCard from './ModelQuestionsCard.vue';
import type { ResponseModel } from '~/interfaces/api';
import { useGlobalStore } from '~/stores/global';
import { modelsQuestions } from '~/api/pageModel';
import { useMediaQueryStore } from '~/stores/mediaQuery';

const props = defineProps({
  perPage: {
    type: Number,
    default: 20,
  },
  model: {
    type: Object as () => ResponseModel,
    required: true,
  },
  pageData: {
    type: Object as () => ResponseModel,
    required: true,
  },
  widePagination: Boolean,
  whenVisible: Boolean,
  changedPage: Boolean,
  isBaseTab: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['change-data', 'to-route', 'close']);
const globalStore = useGlobalStore();
const pageCount = ref<number>(
  Math.ceil(props.model.questions_count / props.perPage)
);
const questions = ref();
const showFeedbackModal = ref(false);
const showConfirmModal = ref(false);
const activePage = ref<number>(questions.value?.page || 1);
const totalQuestions = computed(
  () => props.model.questions_count || props.pageData?.questions?.total
);
const questionsElement = ref<HTMLElement>();
const questionText = ref<HTMLElement[]>();
const isBot = computed(() => globalStore.isBot);
const isPadding = computed(() => {
  return questions.value?.items?.length < 1;
});

const mediaStore = useMediaQueryStore();
const isMobile = computed(() => mediaStore.isMobile);
const isMd = computed(() => mediaStore.isMd);
const isLessLg = computed(
  () => mediaStore.isEs || mediaStore.isSm || mediaStore.isMd
);
const articleInView = computed(() => {
  if (!props.isBaseTab) return props.perPage;
  return mediaStore.isEs || mediaStore.isSm || mediaStore.isMd ? 6 : 3;
});
const { $ymAnyEvent } = useNuxtApp();
const isOtzyvyList = computed(
  () => questions.value && !!questions.value?.items?.length
);

async function getModelReviews(modelId: number) {
  const questionsList = await modelsQuestions(modelId, {
    per_page: props.perPage,
    page: activePage.value,
    external: !isBot.value,
    region_id: globalStore.region.id,
    // антикеш
    tbp: `${modelId}${+new Date()}rew`,
  });

  if (questionsList) {
    questions.value = questionsList;
    emit('change-data', {
      key: 'questions',
      data: questionsList,
    });
  } else {
    emit('change-data', {
      key: 'questions',
      data: { items: [], per_page: 0, total: 0 },
    });
    pageCount.value = 1;
    activePage.value = 1;
  }
}

function setActive(active: number) {
  activePage.value = active;
  if (window && questionsElement.value) {
    const y = questionsElement.value.getBoundingClientRect().top - 90;
    window.scrollTo({
      top: window.scrollY + y,
      left: 0,
      behavior: 'smooth',
    });
  }
  getModelReviews(props.model.id);
}

function createNewQuestions(): void {
  $ymAnyEvent('reachGoal', 'click_button_Ask_question');
  showFeedbackModal.value = true;
}

const closeFeedbackModal = (e: string) => {
  showFeedbackModal.value = false;
  if (e === 'success') {
    showConfirmModal.value = true;
  }
};

function initModelReviews() {
  if (
    props.whenVisible &&
    questionsElement.value &&
    questions.value?.per_page !== props.perPage
  ) {
    activePage.value = 1;
    getModelReviews(props.model.id);
  }
}

if (isBot) {
  questions.value = props.pageData.questions;
}

onMounted(() => {
  if (!isBot && props.pageData?.questions !== undefined) {
    questions.value = props.pageData.questions;
  } else {
    nextTick(() => {
      initModelReviews();
    });
  }
});
</script>
<style lang="scss" scoped src="./ModelQuestionsScss.scss"></style>
